import { drawerFooterStyle } from '@shared/style/modal';
import { styled } from 'goober';
import { Typography } from '@shared/ui/typography/typography';

export const DrawerBody = styled('div')`
    display: flex;
    gap: 20px;
    flex-direction: column;
    height: 100%;
`;

export const DrawerFooter = styled('div')`
    display: flex;
    width: 100%;
    justify-content: flex-end;
    ${drawerFooterStyle}
`;

export const Content = styled('div')`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
    padding-bottom: 24px;
`;

export const AccessWrapper = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const MembersWrapper = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const StyledTypography = styled(Typography)`
    margin-bottom: 20px;
`;

export const AdminFooter = styled('div')`
    display: flex;
    width: 100%;
    gap: 8px;
    justify-content: flex-end;
`;

export const InitiatorWrapper = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const FilesList = styled('div')`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
